import { AuthenticateResult } from '@feedyou/schema'

export const MINIMUM_PERMISSIONS: AuthenticateResult = {
  role: 'view',
  analytics: false,
  callsList: false,
  deployBot: false,
  canSeeDeployPermissions: false,
  usersWithDeployPermission: null
}
